import LogicaAPI from "./logicaapi";
class Palette extends LogicaAPI {
  async getPalette(id) {
    return this.get(`/api/v1/palettes/${id}`);
  }
  paletteObjects(id, offset, limit) {
    const params = {
      device_code: this.config.deviceCode,
      app_id: this.config.appId,
      datasource: "decorator",
      with_total_count: true,
      from: offset,
      limit
    };
    return this.get(`/api/v1/palettes/${id}/objects`, {
      params
    });
  }
}
export default Palette;